import { message } from "antd";
import { LeadService } from "../../services/apiServices/leadService";
import { FilterStatus } from "../../libs/types/src";
import moment from "moment";

export const UPLOAD_CSV_REQUEST = 'UPLOAD_CSV_REQUEST';
export const UPLOAD_CSV_SUCCESS = 'UPLOAD_CSV_SUCCESS';
export const UPLOAD_CSV_FAILURE = 'UPLOAD_CSV_FAILURE';

export const GET_LEAD_LISTS_REQUEST = 'GET_LEAD_LISTS_REQUEST';
export const GET_LEAD_LISTS_SUCCESS = 'GET_LEAD_LISTS_SUCCESS';
export const GET_LEAD_LISTS_FAILURE = 'GET_LEAD_LISTS_FAILURE';

export const LOAD_MORE_LEAD_LISTS_REQUEST = 'LOAD_MORE_LEAD_LISTS_REQUEST';
export const LOAD_MORE_LEAD_LISTS_SUCCESS = 'LOAD_MORE_LEAD_LISTS_SUCCESS';
export const LOAD_MORE_LEAD_LISTS_FAILURE = 'LOAD_MORE_LEAD_LISTS_FAILURE';

export const GET_FILTERS_REQUEST = 'GET_FILTERS_REQUEST';
export const GET_FILTERS_SUCCESS = 'GET_FILTERS_SUCCESS';
export const GET_FILTERS_FAILURE = 'GET_FILTERS_FAILURE';

export const ADD_FILTER_REQUEST = 'ADD_FILTER_REQUEST';
export const ADD_FILTER_SUCCESS = 'ADD_FILTER_SUCCESS';
export const ADD_FILTER_FAILURE = 'ADD_FILTER_FAILURE';

export const TOGGLE_FILTER_REQUEST = 'TOGGLE_FILTER_REQUEST';
export const TOGGLE_FILTER_SUCCESS = 'TOGGLE_FILTER_SUCCESS';
export const TOGGLE_FILTER_FAILURE = 'TOGGLE_FILTER_FAILURE';

export const DELETE_FILTER_REQUEST = 'DELETE_FILTER_REQUEST';
export const DELETE_FILTER_SUCCESS = 'DELETE_FILTER_SUCCESS';
export const DELETE_FILTER_FAILURE = 'DELETE_FILTER_FAILURE';

export const GET_FILTERED_LEADS_REQUEST = 'GET_FILTERED_LEADS_REQUEST';
export const GET_FILTERED_LEADS_SUCCESS = 'GET_FILTERED_LEADS_SUCCESS';
export const GET_FILTERED_LEADS_FAILURE = 'GET_FILTERED_LEADS_FAILURE';

export const EXPORT_FILTERED_LEADS_REQUEST = 'EXPORT_FILTERED_LEADS_REQUEST';
export const EXPORT_FILTERED_LEADS_SUCCESS = 'EXPORT_FILTERED_LEADS_SUCCESS';
export const EXPORT_FILTERED_LEADS_FAILURE = 'EXPORT_FILTERED_LEADS_FAILURE';

export const GET_STATS_REQUEST = 'GET_STATS_REQUEST';
export const GET_STATS_SUCCESS = 'GET_STATS_SUCCESS';
export const GET_STATS_FAILURE = 'GET_STATS_FAILURE';

export const GET_LEAD_INFO_REQUEST = 'GET_LEAD_INFO_REQUEST';
export const GET_LEAD_INFO_SUCCESS = 'GET_LEAD_INFO_SUCCESS';
export const GET_LEAD_INFO_FAILURE = 'GET_LEAD_INFO_FAILURE';

export const CLEAR_LEADS = 'CLEAR_LEADS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';

export const DELETE_LEAD_LIST_REQUEST = 'DELETE_LEAD_LIST_REQUEST';
export const DELETE_LEAD_LIST_SUCCESS = 'DELETE_LEAD_LIST_SUCCESS';
export const DELETE_LEAD_LIST_FAILURE = 'DELETE_LEAD_LIST_FAILURE';

export const GET_FILTERS_STATUS_REQUEST = 'GET_FILTERS_STATUS_REQUEST';
export const GET_FILTERS_STATUS_SUCCESS = 'GET_FILTERS_STATUS_SUCCESS';
export const GET_FILTERS_STATUS_FAILURE = 'GET_FILTERS_STATUS_FAILURE';

export const SYNC_LEAD_STATUS_REQUEST = 'SYNC_LEAD_STATUS_REQUEST';
export const SYNC_LEAD_STATUS_SUCCESS = 'SYNC_LEAD_STATUS_SUCCESS';
export const SYNC_LEAD_STATUS_FAILURE = 'SYNC_LEAD_STATUS_FAILURE';

export const SYNC_STATS_SUCCESS = 'SYNC_STATS_SUCCESS';

const uploadCSV = (file: File, list_name: string) => {
  return async (dispatch: any) => {
    message.loading('Uploading CSV...');
    dispatch(request());
    try {
      const response = await LeadService.uploadCSV(file, list_name);
      message.destroy();
      message.success('CSV uploaded successfully');
      dispatch(getLeadLists({ page: 1, page_size: 10 }));
      dispatch(success(response.data));

    } catch (error) {
      message.destroy();
      message.error('Failed to upload CSV');
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: UPLOAD_CSV_REQUEST };
  }
  function success(response: any) {
    return { type: UPLOAD_CSV_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: UPLOAD_CSV_FAILURE, error };
  }
}

const getLeadLists = (params: any = {}) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.getLeadLists(params);
      dispatch(success(response.data));
    } catch (error) {
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: GET_LEAD_LISTS_REQUEST };
  }
  function success(response: any) {
    return { type: GET_LEAD_LISTS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: GET_LEAD_LISTS_FAILURE, error };
  }
}

const loadMoreLeadLists = (params: any = {}) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.getLeadLists(params);
      dispatch(success(response.data));
    } catch (error) {
      dispatch(failure(error));
    }
  }
  function request() {
    return { type: LOAD_MORE_LEAD_LISTS_REQUEST };
  }
  function success(response: any) {
    return { type: LOAD_MORE_LEAD_LISTS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: LOAD_MORE_LEAD_LISTS_FAILURE, error };
  }
}

const syncLeadStatus = () => {
  return async (dispatch: any, getState: any) => {
    const leadLists = getState().leads.leadLists;
    const unprocessedFilters = leadLists.filter((lead: any) => ![FilterStatus.PROCESSED, FilterStatus.FAILED].includes(lead.status));
    const ids = unprocessedFilters.map((lead: any) => lead.id);
    dispatch(request());
    try {
      if (ids.length === 0) return;
      const response = await LeadService.getLeadLists({ id__in: ids.join(',') });
      dispatch(success(response.data));
      dispatch(syncStats());
    } catch (error) {
      dispatch(failure(error));
    }
  }
  function request() {
    return { type: SYNC_LEAD_STATUS_REQUEST };
  }
  function success(response: any) {
    return { type: SYNC_LEAD_STATUS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: SYNC_LEAD_STATUS_FAILURE, error };
  }
}

const getFilters = (params: any = {}) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.getFilters(params);
      dispatch(success(response.data));
    } catch (error) {
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: GET_FILTERS_REQUEST };
  }
  function success(response: any) {
    return { type: GET_FILTERS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: GET_FILTERS_FAILURE, error };
  }
}

const getFiltersStatus = () => {
  return async (dispatch: any, getState: any) => {
    const filters = getState().leads.filters;
    const unprocessedFilters = filters.filter((filter: any) => ![FilterStatus.PROCESSED, FilterStatus.FAILED].includes(filter.status));
    const ids = unprocessedFilters.map((filter: any) => filter.id);
    dispatch(request());
    try {
      if (ids.length === 0) return;
      const response = await LeadService.getFilters({ id__in: ids.join(',') });
      dispatch(success(response.data));
    } catch (error) {
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: GET_FILTERS_STATUS_REQUEST };
  }
  function success(response: any) {
    return { type: GET_FILTERS_STATUS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: GET_FILTERS_STATUS_FAILURE, error };
  }
}

const addFilter = (filter: { name: string, query: string, file_id: string }) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.addFilter(filter);
      message.success('Filter added successfully');
      dispatch(success(response.data));
    } catch (error) {
      message.error('Failed to add filter');
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: ADD_FILTER_REQUEST };
  }
  function success(response: any) {
    return { type: ADD_FILTER_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: ADD_FILTER_FAILURE, error };
  }
}

const toggleFilter = (filterId: string, is_active: boolean) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.updateFilter({ id: filterId, is_active: is_active });
      message.success(is_active ? 'Filter activated successfully' : 'Filter deactivated successfully');
      dispatch(success(response.data));
    } catch (error) {
      message.error(is_active ? 'Failed to activate filter' : 'Failed to deactivate filter');
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: TOGGLE_FILTER_REQUEST };
  }
  function success(response: any) {
    return { type: TOGGLE_FILTER_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: TOGGLE_FILTER_FAILURE, error };
  }
}

const deleteFilter = (filterId: string) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      await LeadService.deleteFilter(filterId);
      message.success('Filter deleted successfully');
      dispatch(success(filterId));
    } catch (error) {
      message.error('Failed to delete filter');
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: DELETE_FILTER_REQUEST };
  }
  function success(id: string) {
    return { type: DELETE_FILTER_SUCCESS, id };
  }
  function failure(error: any) {
    return { type: DELETE_FILTER_FAILURE, error };
  }
}

const getFilteredLeads = (params: any = {}) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.getFilteredLeads(params);
      dispatch(success(response.data));
    } catch (error) {
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: GET_FILTERED_LEADS_REQUEST };
  }
  function success(response: any) {
    return { type: GET_FILTERED_LEADS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: GET_FILTERED_LEADS_FAILURE, error };
  }
}

const exportFilteredLeads = (params: any = {}) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.exportFilteredLeads(params);

      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `cuegrowth_leads_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      dispatch(success(response.data));
    } catch (error) {
      message.error('Failed to export filtered leads');
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: EXPORT_FILTERED_LEADS_REQUEST };
  }
  function success(response: any) {
    return { type: EXPORT_FILTERED_LEADS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: EXPORT_FILTERED_LEADS_FAILURE, error };
  }
}

const getStats = (params: any = {}) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.getStats(params);
      dispatch(success(response.data));
    } catch (error) {
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: GET_STATS_REQUEST };
  }
  function success(response: any) {
    return { type: GET_STATS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: GET_STATS_FAILURE, error };
  }
}

const syncStats = () => {
  return async (dispatch: any) => {
    try {
      const response = await LeadService.getStats({});
      dispatch(success(response.data));
    } catch (error) {
      console.error(error);
    }
  }

  function success(response: any) {
    return { type: SYNC_STATS_SUCCESS, response };
  }
}

const getLeadInfo = (file_id: string) => {
  return async (dispatch: any) => {
    dispatch(request());
    try {
      const response = await LeadService.getLeadLists({ id: file_id });
      dispatch(success(response.data.data[0]));
    } catch (error) {
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: GET_LEAD_INFO_REQUEST };
  }
  function success(response: any) {
    return { type: GET_LEAD_INFO_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: GET_LEAD_INFO_FAILURE, error };
  }
}

const clearLeads = () => {
  return async (dispatch: any) => {
    dispatch({ type: CLEAR_LEADS });
  }
}

const clearFilters = () => {
  return async (dispatch: any) => {
    dispatch({ type: CLEAR_FILTERS });
  }
}

const deleteLeadList = (leadListId: string) => {
  return async (dispatch: any) => {
    message.loading({ content: 'Deleting...', key: 'deleteLeadList' });
    dispatch(request());
    try {
      await LeadService.deleteLeadList(leadListId);
      dispatch(success(leadListId));
      dispatch(getStats({}));
      message.destroy()
      message.success({ content: 'Deleted successfully!', key: 'deleteLeadList' });
    } catch (error) {
      message.destroy();
      message.error({ content: 'Failed to delete lead list', key: 'deleteLeadList' });
      dispatch(failure(error));
    }
  }

  function request() {
    return { type: DELETE_LEAD_LIST_REQUEST };
  }
  function success(id: string) {
    return { type: DELETE_LEAD_LIST_SUCCESS, id };
  }
  function failure(error: any) {
    return { type: DELETE_LEAD_LIST_FAILURE, error };
  }
}

const exportUploadedFile = (id: string) => {
  return async (dispatch: any) => {
    try {
      const { data: { url: s3Url } } = await LeadService.exportUploadedFile({ id });
      const response = await fetch(s3Url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `leads_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error('Failed to export uploaded file');
    }
  }
}

export const leadActions = {
  uploadCSV,
  getLeadLists,
  loadMoreLeadLists,
  addFilter,
  getFilters,
  getFiltersStatus,
  deleteFilter,
  toggleFilter,
  getFilteredLeads,
  exportFilteredLeads,
  getStats,
  syncStats,
  clearLeads,
  clearFilters,
  getLeadInfo,
  deleteLeadList,
  syncLeadStatus,
  exportUploadedFile
}